<div class="main-container">
  <div *ngIf="!error; else elseBlock">
    <form novalidate [formGroup]="projectForm">
      <mat-card>
        <mat-card-content>
          <!-- Header -->
          <div class="detail-header">
            <span class="card-title">{{ pageTitle }}</span>
            <span class="spacer"></span>
            <button type="button" mat-icon-button *ngIf="!_authService.readOnly"
              [disabled]="!canSave"
              (click)="saveProject()" matTooltip="save" matTooltipPosition="above">
              <mat-icon>save</mat-icon>
            </button>
            <button type="button" mat-icon-button *ngIf="!_authService.readOnly"
              [disabled]="!projectForm.controls.id.value"
              (click)="openModal()" matTooltip="delete project" matTooltipPosition="above">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <!-- Main fields -->
          <div class="detail-main-fields">
            <mat-form-field appearance="fill" class="field-name">
              <mat-label><span class="mandatory">* </span>Project title</mat-label>
              <input matInput formControlName="name" type="text" maxlength="80">
              <mat-error *ngIf="displayMessage.name">{{ displayMessage.name }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="field-department">
              <mat-label><span class="mandatory">* </span>Department</mat-label>
              <mat-select formControlName="department" panelClass="project-detail-select-panel"
                (selectionChange)="onDepartmentChange($event)">
                <mat-option *ngFor="let dep of userDepartments" [value]="dep.department">{{ dep.department }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="field-keycode">
              <mat-label><span class="mandatory">* </span>Key Code</mat-label>
              <input matInput formControlName="keyCode" type="text" maxlength="4">
              <mat-error *ngIf="displayMessage.keyCode">{{ displayMessage.keyCode }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="field-wpr">
              <mat-label>WPR billing code</mat-label>
              <input matInput formControlName="wprBillingCode" type="text" maxlength="10">
            </mat-form-field>

            <mat-form-field appearance="fill" class="field-division">
              <mat-label>Division</mat-label>
              <mat-select formControlName="division" panelClass="project-detail-select-panel">
                <mat-option *ngFor="let div of divisions" [value]="div">{{ div }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-divider class="hide-on-large"></mat-divider>

          <!-- Production Contacts -->
          <div formArrayName="productionContacts">
            <div *ngFor="let contact of projectForm.controls.productionContacts.controls; let i=index">
              <production-contact [readOnly]="_authService.readOnly" [currentItem]="currentProductionContact"
                [group]="contact" [count]="productionContacts.length" [current]="i"
                (addItem)="addProductionContact()" (removeItem)="removeProductionContact(i)"
                (selectedItem)="ProductionContactSelected($event)"></production-contact>
            </div>
          </div>

          <mat-divider class="hide-on-large"></mat-divider>

          <!-- Production Offices -->
          <div formArrayName="productionOffices">
            <div [formGroupName]="i" *ngFor="let office of projectForm.controls.productionOffices.controls; let i=index">
              <production-office [readOnly]="_authService.readOnly" [currentItem]="currentProductionOffice"
                [group]="office" [count]="productionOffices.length" [current]="i"
                (addItem)="addProductionOffice()" (removeItem)="removeProductionOffice(i)"
                (selectedItem)="ProductionOfficeSelected($event)"></production-office>
            </div>
          </div>

          <mat-divider class="hide-on-large"></mat-divider>

          <!-- Project Contacts -->
          <div formArrayName="projectContacts">
            <div [formGroupName]="i" *ngFor="let projContact of projectForm.controls.projectContacts.controls; let i=index">
              <project-contact [readOnly]="_authService.readOnly" [currentItem]="currentProjectContact"
                [lookup]="titles" [tags]="tags" [group]="projContact" [count]="projectContacts.length"
                [current]="i" (addItem)="addProjectContact()" (removeItem)="removeProjectContact(i)"
                (selectedItem)="ProjectContactSelected($event)"></project-contact>
            </div>
          </div>

          <!-- Custom Statuses Toggle -->
          <div class="detail-toggle-row">
            <mat-slide-toggle color="accent"
              formControlName="customStatus"
              (change)="onCustomStatusToggle($event)">
              Custom statuses
            </mat-slide-toggle>
          </div>

          <mat-divider class="hide-on-large" *ngIf="projectForm.get('customStatus')?.value"></mat-divider>

          <!-- Project Statuses -->
          <div formArrayName="projectStatuses" *ngIf="projectForm.get('customStatus')?.value">
            <div [formGroupName]="i" *ngFor="let projectStatus of projectForm.controls.projectStatuses.controls; let i=index">
              <project-status [readOnly]="_authService.readOnly"
                [department]="projectForm.get('department')?.value"
                [currentItem]="currentProjectStatus" [group]="projectStatus"
                [count]="projectStatuses.length" [current]="i"
                (addItem)="addProjectStatus()" (removeItem)="removeProjectStatus(i)"
                (selectedItem)="ProjectStatusSelected($event)"></project-status>
            </div>
          </div>

          <mat-divider class="hide-on-large"></mat-divider>

          <!-- Comments -->
          <div class="detail-comments">
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Comments</mat-label>
              <textarea matInput class="comments-textarea" formControlName="comments" maxlength="32768"
                cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="20"></textarea>
            </mat-form-field>
          </div>

          <mat-divider class="hide-on-large"></mat-divider>

          <!-- Dates -->
          <div class="detail-dates">
            <mat-form-field appearance="fill">
              <mat-label>Start date</mat-label>
              <input matInput [matDatepicker]="startPicker" formControlName="startDate">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Wrap date</mat-label>
              <input matInput [matDatepicker]="wrapPicker" formControlName="wrapDate">
              <mat-datepicker-toggle matSuffix [for]="wrapPicker"></mat-datepicker-toggle>
              <mat-datepicker #wrapPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Release date</mat-label>
              <input matInput [matDatepicker]="releasePicker" formControlName="releaseDate">
              <mat-datepicker-toggle matSuffix [for]="releasePicker"></mat-datepicker-toggle>
              <mat-datepicker #releasePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Documents -->
          <div class="detail-documents">
            <clearance-asset-manager #documentAsset formArrayName="documents" assetType="document"
              asset="document" assetLabel="Choose a File" [projectId]="project.id" [group]="projectForm"
              [documents]="documents" [assetsArray]="projectForm.controls.documents"
              [ownerType]="'project'" [readOnly]="_authService.readOnly">
            </clearance-asset-manager>
          </div>

        </mat-card-content>
        <mat-card-actions class="detail-card-actions" align="end">
          <button type="button" mat-button class="detail-footer-cancel" (click)="goBack()">Cancel</button>
          <button type="button" mat-button class="detail-footer-save" *ngIf="!_authService.readOnly"
            (click)="saveProject()"
            [disabled]="!canSave">{{ SaveLabel }}</button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
  <ng-template #elseBlock>
    <div class="error-message">{{ error }}</div>
  </ng-template>
</div>
